import { Product } from "./models/Product";
import { Supplier } from "@domain/suppliers/models/Supplier";

/**
 * Whether `supplierId` may supply `product`: `supplierProducts` on product, then `supplierLinks`,
 * then supplier `supplierProducts`. If no constraining data, returns true (do not block).
 */
function supplierSuppliesProduct(
  supplierId: string,
  product: Product,
  supplier: Supplier | undefined
): boolean {
  const supplierProducts = product.supplierProducts;
  if (supplierProducts?.length) {
    return supplierProducts.some(lp => lp.supplierId === supplierId);
  }
  const links = product.supplierLinks;
  if (links?.length) {
    return links.some(l => l.supplierId === supplierId);
  }
  if (supplier?.supplierProducts?.length) {
    return supplier.supplierProducts.some(lp => lp.product?.id === product.id);
  }
  return true;
}

/**
 * True when the supplier may supply every selected product.
 * Uses `product.supplierLinks` when present; otherwise uses `supplier.supplierProducts` from
 * `suppliers` so inventory rows without embedded links still constrain chips.
 */
export function isSupplierLinkedToAllProducts(
  supplierId: string,
  products: Product[],
  suppliers?: Supplier[]
): boolean {
  if (products.length === 0) return true;
  const supplier = suppliers?.find(s => s.id === supplierId);
  return products.every(p => supplierSuppliesProduct(supplierId, p, supplier));
}
